import SigamAPI from '~/utils/SigamAPI';

export default async function ReadTemplate({ institutionId, data }) {
  const response = await SigamAPI({
    url: `/SIGAM/${institutionId}/communication-models`,
    method: 'POST',
    data: data,
  });

  return response;
}
